import { Content, Portal, Root, Trigger } from '@radix-ui/react-popover';
import { PropsWithChildren, ReactNode } from 'react';

import { Button } from './components/button/button';
import { Close } from './components/close';
import styles from './popover.module.css';
import { List } from '../list/list';
import { ListItem } from '../list/list-item';

type PopoverProps = PropsWithChildren<{
  trigger: ReactNode;
  offset: number;
}>;
export const Popover = ({ trigger, children, offset }: PopoverProps) => (
  <Root>
    <Trigger asChild>{trigger}</Trigger>
    <Portal>
      <Content className={styles.popover} align="end" sideOffset={offset}>
        {children}
      </Content>
    </Portal>
  </Root>
);
Popover.List = List;
Popover.ListItem = ListItem;
Popover.Button = Button;
Popover.Close = Close;
